import React from 'react';
import { Card, CardHeader, CardBody, CardFooter, Button } from 'reactstrap';

interface IProps {
  cardTitle: string;
  children?: React.ReactNode;
}

export const AcademicOverviewCard = ({ cardTitle, children }: IProps) => {
  return (
    <Card>
      <CardHeader>
        <h5 className="fw-semibold">{cardTitle}</h5>
      </CardHeader>
      <CardBody>{children}</CardBody>
      {/* <CardFooter className="d-flex justify-content-end">
        <Button>Exportar</Button>
      </CardFooter> */}
    </Card>
  );
};
